import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { SpamProtectionComponent } from './security.spam-protection.component';

angular.module('app-lite.security', [])
  .directive('worSpamProtection', downgradeComponent({ component: SpamProtectionComponent }) as ng.IDirectiveFactory);
